// extracted by mini-css-extract-plugin
export default {"root":"_4X61M","left":"_2dqIn","right":"_1kI6E","author":"_3bXXZ","actions":"_1UNhz"};